import createDependencyContext from 'adapter/in/common/dependenciesContext';
import ReadPresetField from 'use-case/presets/fields/read/readPresetField';
import ReadPresetForm from 'use-case/presets/form/readPresetFormClient';

import readWidgetDataUseCase, { ReadWidgetData } from 'use-case/widgets/data/read/readWidgetDataUseCase';
import readWidgetDataApiClient from 'adapter/out/client/widgets/data/readWidgetDataApiClient';

import readWidgetUseCase, { ReadWidget } from 'use-case/widget/read/readWidgetUseCase';
import readWidgetApiClient from 'adapter/out/client/widget/readWidgetApiClient';

import readPresetFormUseCase from 'use-case/presets/form/readPresetFormUseCase';
import readPresetFormApiClient from 'adapter/out/client/presets/form/readPresetFormApiClient';

import readPresetFieldUseCase from 'use-case/presets/fields/read/readPresetFieldUseCase';
import readPresetFieldApiClient from 'adapter/out/client/presets/fields/readPresetFieldApiClient';

import updateWidgetUseCase, { UpdateWidget } from 'use-case/widget/update/updateWidgetUseCase';
import updateWidgetApiClient from 'adapter/out/client/widget/updateWidgetApiClient';

export interface ICommonDependencies {
    readWidget: ReadWidget;
    readPresetForm: ReadPresetForm;
    readPresetField: ReadPresetField;
    updateWidget: UpdateWidget;
}

export interface ICommonDataDependencies {
    readWidgetData: ReadWidgetData;
}

const CommonDependenciesContext = createDependencyContext<ICommonDependencies>();

const DataDependenciesContext = createDependencyContext<ICommonDataDependencies>();

export const getCommonDependencies = (fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>, baseUrl: string) => ({
    readWidget: readWidgetUseCase(readWidgetApiClient(fetch, baseUrl)),
    readPresetForm: readPresetFormUseCase(readPresetFormApiClient(fetch, baseUrl)),
    readPresetField: readPresetFieldUseCase(readPresetFieldApiClient(fetch, baseUrl)),
    updateWidget: updateWidgetUseCase(updateWidgetApiClient(fetch, baseUrl)),
});

export const getDataDependencies = (fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>, baseUrl: string) => ({
    readWidgetData: readWidgetDataUseCase(readWidgetDataApiClient(fetch, baseUrl)),
});

export const { Provider: CommonDependenciesContextProvider, useDependencies: useCommonDependencies } = CommonDependenciesContext;

export const { Provider: DataDependenciesContextProvider, useDependencies: useDataDependencies } = DataDependenciesContext;
